import { API } from "aws-amplify";
import * as APITypes from "~/API";
import { createMonthlyFinanceReport } from "~/graphql/mutations";
import { LoaderData } from "~/types";

const EMPTY_MONTHLY_REPORT: APITypes.MonthlyFinanceReport = {
  __typename: "MonthlyFinanceReport",
  id: "",
  yearlyReportId: "",
  entityID: "",
  entityType: "",
  month: 0,
  year: 0,
  createdAt: "",
  updatedAt: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  _version: 0,
  _lastChangedAt: 0,
};

export const addMonthlyReportDetails = async (
  payload: APITypes.CreateMonthlyFinanceReportInput
): Promise<LoaderData<APITypes.MonthlyFinanceReport>> => {
  try {
    const response = (await API.graphql({
      query: createMonthlyFinanceReport,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.CreateMonthlyFinanceReportMutation };

    return {
      success: true,
      data: response.data?.createMonthlyFinanceReport || EMPTY_MONTHLY_REPORT,
    };
  } catch (error) {
    console.log("Error adding monthly report", error);
    return {
      success: false,
      data: EMPTY_MONTHLY_REPORT,
      error,
    };
  }
};
